import { CartDetails } from "../../lib/cart/CartDetails";
import { FONT_SETTINGS } from "../../fonts";
import { FamilyDetails } from "../../lib/models/Licensing";
import FoundryLink from "../../components/FoundryLink";
import Routes from "../../routes";
import { formatMoneyShort } from "../../util/strings";

interface Props {
  familyName: string;
  familyDetails: FamilyDetails;
  cartDetails: CartDetails;
}

export default function FontFamilySection({
  familyName,
  familyDetails,
  cartDetails,
}: Props) {
  const font = FONT_SETTINGS[familyName];

  return (
    <>
      <div className="flex flex-row gap-8">
        <FoundryLink
          href={Routes.fonts.add.styles(familyName)}
          className={`w-24 h-24 bg-${font.accentColor} flex items-center justify-center t2 rounded-lg color-blue-hover`}
          style={{ fontFamily: familyDetails.items[0]?.cssName }}
        >
          Aa
        </FoundryLink>

        <div className="flex flex-col flex-grow">
          {familyDetails.items.map((entry) => {
            // TODO: Take in line items instead of recalculating this
            const price = entry.getBasePrice(
              familyDetails.platforms.length,
              cartDetails.licenseUsage?.isEducationalLicense || false
            );

            const discount = entry.getDiscount(familyDetails.items);

            return (
              <>
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-col justify-center">
                    <span>
                      <FoundryLink
                        href={Routes.fonts.add.styles(familyName)}
                        className="color-blue-hover"
                        style={{ fontFamily: entry.cssName }}
                      >
                        {entry.name}
                      </FoundryLink>
                    </span>
                  </div>
                  <div>
                    <span
                      className={`${
                        discount ? "line-through opacity-50 ml-4" : "ml-4"
                      }`}
                    >
                      {formatMoneyShort("USD", price)}
                    </span>
                    {discount && (
                      <span className="ml-4 color-green">
                        {formatMoneyShort(
                          "USD",
                          (1.0 - discount.discount) * price
                        )}
                      </span>
                    )}
                  </div>
                </div>
              </>
            );
          })}
          <span className="mb-2 text-sm opacity-70 mt-4">
            <FoundryLink
              href={Routes.fonts.add.licenseTypes(familyName)}
              className="color-blue-hover"
            >
              → Licensed Platforms: {familyDetails.platforms.join(", ")}
            </FoundryLink>
          </span>
        </div>
      </div>
    </>
  );
}
